module.exports = __webpack_public_path__ + "img/thumb-sarah-off.8d5bebab.jpg";